import { render, staticRenderFns } from "./TelefonoView.vue?vue&type=template&id=37ba2a94"
import script from "./TelefonoView.vue?vue&type=script&lang=js"
export * from "./TelefonoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports